<template>
	<dl class="select-line">
		<dt>{{title}}</dt>
		<dd v-for="(item, index) in option" :key="index + item.name" :class="{'act': item.act, 'hover-act': !item.disabled}" >
			<span @click="parentClick(item, index)">{{item.name}}</span>
			<em v-if="item.act && !item.noClose" @click="closeFn(item)">×</em>
		</dd>
	</dl>
</template>

<script>
export default {
	name: 'pt-select-line',
	data () {
		return {
			option: []
		}
	},
	props: {
		value: {
			type: Array,
			required: true
		},
		datas: {
			type: Array,
			default: null,
			required: true
		},
		title: {
			type: String,
			default: ''
		},
		multiple: {
			type: Boolean,
			default: true
		},
	},
	watch: {
		datas () {
			this.init()
		},
		value () {
			if (this.value.length == 0) {
				this.option = JSON.parse(JSON.stringify(this.datas))
				this.option.forEach((value) => {
					value.act = false
				})
			}
		}
	},
	methods: {
		init () {
			this.option = JSON.parse(JSON.stringify(this.datas))
			this.option.forEach((value) => {
				value.act = false
				if (this.value.length != 0) {
					for (let x in this.value) {
						if (this.value[x] == value.code) value.act = true
					}
				}
			})
			for (let x in this.option) {
				if (this.option[x].act) {
					this.checkValue()
				}
			}
		},
		parentClick (item,index) {
			const experience = this.$route.query.experience || '0'
			if ( item.isDisabled && item.isDisabled === true && experience === '0' ) return
			if (this.title === '页面类别') return
			if (!this.multiple && !this.option[index].act) {
				this.option.forEach(function (value) {
					if (value.act) value.act = false
				})
			}
			this.option[index].act = !this.option[index].act
			this.checkValue()
		},
		closeFn (item) {
			const experience = this.$route.query.experience || '0'
			if ( item.isDisabled && item.isDisabled === true && experience === '0' ) return
			for (let x in this.option) {
				if (this.option[x].code === item.code) {
					this.option[x].act = false
				}
			}
			this.checkValue()
		},
		checkValue () {
			let arr = []
			this.option.forEach((value, index) => {
				if (value.act) {
					arr.push({
						code: value.code,
						name: value.name
					})
				}
			})
			this.$emit('input', arr)
			this.$emit('ClickFn')
		},
	},
	created () {
		this.init()
	}

}

</script>

<style lang='scss' scoped>
.select-line {
	position: relative;
	padding: 0 40px 0 160px;
	margin-bottom: 15px;
	font-size: 0;
	min-height: 46px;

	dt {
		position: absolute;
		left: 58px;
		top: 0px;
		font-size: 16px;
		color: #0a54c2;
		line-height: 46px;
	}

	dd {
		position: relative;
		display: inline-block;
		margin: 5px;
		line-height: 36px;
		font-size: 14px;
		color: #474747;
		border-radius: 25px;
		cursor: pointer;
		-webkit-transition: 0.2s;
		-moz-transition: 0.2s;
		transition: 0.2s;
		border: 1px solid #fff;

		&.hover-act:hover {
			color: #fff;
			background: #f89211;
		}

		&.act {
			border: 1px solid #f89211;
			background: #f89211;
			color: #fff;
		}

		span {
			display: block;
			height: 36px;
			padding: 0 30px;
			line-height: 36px;
		}

		em {
			position: absolute;
			top: 0;
			right: 0;
			width: 14px;
			height: 14px;
			line-height: 10px;
			font-size: 12px;
			border-radius: 50%;
			border: 1px solid #0a54c2;
			color: #0a54c2;
			background: #fff;
			text-align: center;
			transition: 0.3s;

			&:hover {
				background: #e4393c;
				color: #fff;
				border: 1px solid #e4393c;
			}
		}
	}
}
</style>
